// namespace Pacem.Animations {
export class Timer {
    #fps;
    #callback;
    #handle;
    constructor(callback, fps) {
        this.#then = 0;
        this._run = (t) => {
            this.#handle = requestAnimationFrame(this._run);
            const now = performance.now(), fps = this.#fps;
            const delta = now - this.#then;
            if (delta >= fps) {
                this.#then = now - (delta % fps);
                this.#callback(t);
            }
        };
        this.#fps = 1000 / fps;
        this.#callback = callback;
        this.#handle = requestAnimationFrame(this._run);
    }
    #then;
    static run(callback, fps = 60) {
        return new Timer(callback, fps);
    }
    stop() {
        cancelAnimationFrame(this.#handle);
    }
}
;
// }
